import { Component, Input } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { IncidentEvent } from '../../../../../core/models/live-events'
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'app-redirection-to-event',
  standalone: true,
  imports: [IonicModule],
  template: `
    <a target="_blank" href="{{ redirectToLiveEvent() }}">
      <ion-icon src="./assets/svgs/live-events/live_event_logo.svg" />
      <span>+ d'info</span>
    </a>`,
  styleUrl: './redirection-to-event.component.scss',
})
export class RedirectionToEventComponent {
  @Input() incident: IncidentEvent

  redirectToLiveEvent(): string {
    return `${environment.liveEventsBaseUrl}/incidents/${this.incident?.eventId}/filactu`
  }
}
